import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { format } from 'date-fns'

import { BoldMedBodyText, MedBodyText } from '../styles/Text'
import { FlexEndContainer, SpaceBetweenRowContainer } from '../styles/Containers'
import PIRStatus from './PIRStatus'

const RowData = styled(SpaceBetweenRowContainer)`
  width: 100%;

  text-wrap: wrap;
  word-break: break-word;
`

const Item = styled.div`
  flex-basis: ${props => (props.size === 'small' ? '27%' : '38%')};
`

const SmallItem = styled.div`
  flex-basis: ${props => (props.size === 'small' ? '19%' : '24%')};
`

const LastItem = styled(FlexEndContainer)`
  min-width: 115px;
`

function PIR({ pir, displayRequestor = true }) {
  const { pirId, address, postalCode, requestor, lastUpdated, status } = pir

  return (
    <SpaceBetweenRowContainer>
      <RowData>
        <Item size={displayRequestor ? 'small' : 'large'}>
          <BoldMedBodyText>{pirId}</BoldMedBodyText>
        </Item>
        <Item size={displayRequestor ? 'small' : 'large'}>
          <BoldMedBodyText>{address}</BoldMedBodyText>
          <MedBodyText>{postalCode}</MedBodyText>
        </Item>
        {displayRequestor && (
          <Item size="small">
            <BoldMedBodyText>{requestor}</BoldMedBodyText>
          </Item>
        )}
        <SmallItem size={displayRequestor ? 'small' : 'large'}>
          <BoldMedBodyText>{format(lastUpdated, 'yyyy-MM-dd')}</BoldMedBodyText>
          <MedBodyText>{format(lastUpdated, 'hh:mm a')}</MedBodyText>
        </SmallItem>
      </RowData>
      <LastItem>
        <PIRStatus status={status} />
      </LastItem>
    </SpaceBetweenRowContainer>
  )
}

PIR.propTypes = {
  pir: PropTypes.shape({
    pirId: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    requestor: PropTypes.string.isRequired,
    lastUpdated: PropTypes.instanceOf(Date).isRequired,
    status: PropTypes.oneOf(['PAID', 'SIGNING', 'READY', 'COMPLETED', 'REJECTED', 'EXPIRED']).isRequired
  }),
  displayRequestor: PropTypes.bool
}

export default PIR
